import React from 'react';
import { ImgUploaderForStyleSettings } from 'components/ImgUploader/ImgUploaderForStyleSettings';

interface IProps {
	translationId: string;
	isMakeImageRequest: boolean;
}

export const CarouselImgItem: React.FC<IProps> = React.memo(({ translationId, isMakeImageRequest }) => {
	return (
		<ImgUploaderForStyleSettings
			translationID={translationId}
			photoSize="Medium"
			isMakeImageRequest={isMakeImageRequest}
			loaderSize="big"
			noImageIdIcon="twoHills"
			isUseInSlider={true}
		/>
	);
});
